// userService.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, tap, throwError } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CategoryDTO } from '../components/category/category.model'; // Add department model
import { baseURL, getHeaders, VERSION } from '../constant/constant';
import { error } from 'console';
import type { ResponseCommonForList } from '../dtos/ResponseDTOs';
import type { Category } from '../dtos/Category';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private pageSize = 10;
  
    private currentPageSubject = new BehaviorSubject<number>(0);
    private pageSizeSubject =   new BehaviorSubject<number>(this.pageSize);
  
    currentPage$ = this.currentPageSubject.asObservable();
    pageSize$ = this.pageSizeSubject.asObservable()

  constructor(private http: HttpClient) { }

  create(categoryDTO: CategoryDTO): Observable<CategoryDTO> {
    return this.http.post<CategoryDTO>(`${baseURL}categories/${VERSION}`, categoryDTO, getHeaders());
  }

  getAllCategory(): Observable<ResponseCommonForList<Category>> {
    const options = {
      headers: getHeaders().headers
    };
    return this.http.get<ResponseCommonForList<Category>>(`${baseURL}categories/${VERSION}/list`, options)
      .pipe(
        tap(),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  getAllCategoriesByDepartment(): Observable<ResponseCommonForList<Category>> {
    const options = {
      headers: getHeaders().headers
    };
    return this.http.get<ResponseCommonForList<Category>>(`${baseURL}categories/${VERSION}/listByDepartment`, options)
      .pipe(
        tap(),
        catchError(error => throwError(() => error))
      );
  }

  getAllCategoryForFilter(filters: any, page: number = 0, size: number = 10): Observable<any> {
      let params = new HttpParams()
      .set('pageNo', page.toString())
      .set('pageSize', size.toString());
  
      if(filters) {
        if(filters.departmentIds) {
          params = params.set('departmentIds', filters.departmentIds);
        }
        if(filters.categoryTypeIds) {
          params = params.set('categoryTypeIds', filters.categoryTypeIds);
        }
        if(filters.ids) {
          params = params.set('ids', filters.ids);
        }
      }
      return this.http.get<any>(`${baseURL}categories/${VERSION}/list1`, {
        params,
        headers: getHeaders().headers
      }).pipe(
        tap(),
        catchError(error => {
          console.error("Error Fetching All Categories.");
          return throwError(() => new Error('error'))
        })
      );
    }

  getCategoryType(): Observable<any[]> {
    const options = {
      headers: getHeaders().headers
    };
    return this.http.get<any[]>(`${baseURL}categories/${VERSION}/category/type`, options)
      .pipe(
        tap(),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  getCategoryById(id: number): Observable<CategoryDTO> {
    return this.http.get<CategoryDTO>(`${baseURL}categories/${VERSION}?id=${id}`, getHeaders());
  }

  update(CategoryDTO: CategoryDTO): Observable<CategoryDTO> {
    return this.http.put<CategoryDTO>(`${baseURL}categories/${VERSION}`, CategoryDTO, getHeaders()).pipe(
      tap(),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  deleteById(id: number): Observable<CategoryDTO> {
    return this.http.delete<CategoryDTO>(`${baseURL}categories/${VERSION}?id=${id}`, getHeaders());
  }

  
}